// extracted by mini-css-extract-plugin
export default {"root":"SystemBubble_root__Bd3WW","mediaPreview":"SystemBubble_mediaPreview__R1qbW","playBtn":"SystemBubble_playBtn__VnvZf"};